import isSecureCookie from 'shared/utils/isSecureCookie'
import {
  AUTH_COOKIE_NAME,
  AUTH_COOKIE_NAME_CHECKOUT
} from 'shared/consts/authCookie'
import Cookies, { SetOption } from 'cookies'

const COOKIE_EXPIRATION = 24 * 60 * 60 * 1000
const TOKEN_TYPE = 'Bearer'
const TOKEN_TYPE_REGEX = /^BEARER /gi
export const defaultCookieOptions: SetOption = {
  httpOnly: true,
  maxAge: COOKIE_EXPIRATION,
  overwrite: true,
  path: '/',
  sameSite: 'strict'
}

function prepareToken(token: string) {
  return token.replace(TOKEN_TYPE_REGEX, '').trim()
}

const checkRedirectPaths = url =>
  url.includes('/redirect') || url.includes('/experiments')

const checkoutPath = (cookies: Cookies): string => {
  try {
    const pathSplit = cookies.request?.url?.split('/')
    const checkoutIndex = pathSplit.findIndex(it => it.includes('checkout'))
    const paths: string[] = pathSplit.slice(0, checkoutIndex + 1)
    paths.push('redirect')

    return paths.join('/')
  } catch {
    return '/'
  }
}

export function setAuthCookie(cookies: Cookies, token: string): void {
  try {
    const cookieValue = prepareToken(token)

    cookies.set(AUTH_COOKIE_NAME, cookieValue, {
      ...defaultCookieOptions,
      sameSite: 'lax',
      secure: isSecureCookie
    })
  } catch (e) {
    if (typeof window === 'undefined') {
      throw e
    }
  }
}

export function getAuthCookie(cookies: Cookies): string | undefined {
  let token = cookies.get(AUTH_COOKIE_NAME)

  if (!token && checkRedirectPaths(cookies?.request?.url || '')) {
    token = cookies.get(AUTH_COOKIE_NAME_CHECKOUT)
  }

  if (!token) {
    return undefined
  }

  return `${TOKEN_TYPE} ${token}`
}

export function getPlainAuthCookie(cookies: Cookies): string | undefined {
  let token = cookies?.get(AUTH_COOKIE_NAME)

  if (!token && checkRedirectPaths(cookies?.request?.url || '')) {
    token = cookies.get(AUTH_COOKIE_NAME_CHECKOUT)
  }

  return token
}

export function deleteAuthCookie(cookies: Cookies): void {
  cookies.set(AUTH_COOKIE_NAME, '', { ...defaultCookieOptions, maxAge: -1 })
}

export function setCheckoutCookie(cookies: Cookies): void {
  try {
    const checkout = cookies.get(AUTH_COOKIE_NAME_CHECKOUT)
    if (checkout) return

    const token = cookies.get(AUTH_COOKIE_NAME)
    if (!token) return

    const cookieValue = prepareToken(token)
    const path = checkoutPath(cookies)

    cookies.set(AUTH_COOKIE_NAME_CHECKOUT, cookieValue, {
      ...defaultCookieOptions,
      path,
      sameSite: 'none',
      secure: true
    })
  } catch {
    // do nothing
  }
}

export function deleteCheckoutCookie(cookies: Cookies): void {
  try {
    const checkout = cookies.get(AUTH_COOKIE_NAME_CHECKOUT)

    if (!checkout) return

    cookies.set(AUTH_COOKIE_NAME_CHECKOUT, '', {
      ...defaultCookieOptions,
      maxAge: -1
    })
  } catch {
    // do nothing
  }
}
